import{getUrlParamValue as r}from"./get-url-param-value.js";const a=(a,t)=>{const e=new URLSearchParams(t);if(Array.isArray(a)){const t={};return a.forEach((a=>{t[a]=r(a,e)})),t}return r(a,e)};export{a as getUrlParams};
